module.exports = __webpack_public_path__ + "static/media/mod-lp.c57346f1.png";